import { Box, styled } from "@mui/material";

export const DayContainer = styled(Box)({
    display: 'grid',
    height: '40px',
    width: '40px',
    placeItems: 'center stretch',
})